import { render } from "./QBEOperator.vue?vue&type=template&id=10106d5e&ts=true"
import script from "./QBEOperator.vue?vue&type=script&lang=ts"
export * from "./QBEOperator.vue?vue&type=script&lang=ts"

import "./QBEOperator.vue?vue&type=style&index=0&id=10106d5e&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__